import { HStack } from '@chakra-ui/react';

import { Typography } from 'shared';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { useConfirmationModal } from 'shared/hooks';

export const useScheduledMessageDeleteConfirmation = ({
  scheduledFor,
  interlocutorName,
  onConfirm,
}: {
  scheduledFor: string;
  interlocutorName: string;
  onConfirm: () => void;
}) => {
  const content = (
    <HStack gap={1}>
      <Typography color="gray" type="meta">
        This will delete this scheduled message (
        {dateUtils(scheduledFor).format('MMM D')}) for
      </Typography>
      <Typography color="blue" type="meta">
        {interlocutorName}
      </Typography>
    </HStack>
  );

  return useConfirmationModal({
    title: 'Delete scheduled message?',
    content,
    onConfirm,
  });
};
